import React from "react";

function AddPopup() {
  return (
    <div className="add-popup">
      <div className="wrapper">
        <div className="title">
          광고를 <br />
          등록하시겠습니까?
        </div>
        <div className="sub">등록 시 홈페이지 메인에 바로 업로드 됩니다</div>
        <div className="img">
          <img src="/assets/common/character.svg" alt=""></img>
        </div>

        <div className="button">홈페이지에 등록하기</div>
      </div>
    </div>
  );
}

export default AddPopup;
